import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { getOriginList } from "../../config";
import { getGameParentData } from "../../utilities/games";
import { setPrint, setSave } from "../../utilities/print";
import { sendResponse } from "../../utilities";
import routeCodes from "../../config/routeCodes";

export default function MessageHandler(props) {
  const location = useLocation();

  const eventFunction = async (e) => {
    if (getOriginList().includes(e.origin)) {
      const message = e[e.message ? "message" : "data"];

      if (message?.source === "game") {
        const { type, payload } = message;
        switch (type) {
          case "handshake":
            message.payload = getGameParentData(location);
            message.status = "complete";
            sendResponse(message, e.origin);
            break;

          case "saveImage":
            setSave({
              eventLabel: location.pathname,
              fileData: payload.data,
              fileName: payload.fileName,
              origin: e.origin,
              silent: message.silent,
              message: JSON.stringify(message),
            });
            break;

          case "printImage":
            setPrint({
              eventLabel: location.pathname,
              fileData: payload.data,
              fileName: payload.fileName,
              origin: e.origin,
              silent: message.silent,
              message: JSON.stringify(message),
            });
            break;

          case "analytics":
            if (location.pathname.startsWith(routeCodes.GAMEPROXY)) {
              const gameEmbeded = window.parent.location !== window.location;

              if (gameEmbeded) {
                // only if gameproxy is embeded in an iframe
                // parent is not itself
                // send message to parent embeding gameproxy page
                // currently just IXL domains
                window.parent.postMessage(message, "*");
              }
            }
            break;

          default:
            message.status = "failed";
            message.statusMessage = "Unhandled message!";
            console.error("Unhandled message!", { type, payload });
            sendResponse(message, e.origin);
            break;
        }
      }
    }
  };

  useEffect(() => {
    // listen for incoming events from games/media etc.
    window.addEventListener("message", eventFunction, false);

    return () => {
      // remove listener
      window.removeEventListener("message", eventFunction, false);
    };
  }, []);

  return props.children;
}

MessageHandler.propTypes = {
  children: PropTypes.any,
};
